<script lang="ts">
export default {
  name: 'GridToggle',
};
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { computed, inject } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { LucideGrid3x3 } from '@lucide/vue';

// ---------------
// reactive data
// ---------------
const store = inject<Store<AppState>>('store');

// ----------
// computed
// ----------
const gridModeEnabled = computed<boolean | undefined>(() => {
  return store?.state.towerCanvasState.gridModeEnabled;
});

// ----------
// handlers
// ----------
function handleToggleGrid(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(StoreMutationType.SET_GRID_MODE, !store?.state.towerCanvasState.gridModeEnabled);
}
</script>

<template>
  <div class="self-end py-2">
    <label title="Toggle Grid">
      <input
        type="checkbox"
        name="grid-toggle"
        aria-label="Grid Toggle"
        class="pointer-events-none box-border hidden"
        @click="handleToggleGrid"
      />
      <LucideGrid3x3
        class="button toggle-button border-box pointer-events-auto flex h-10 w-10 cursor-pointer items-center rounded-lg p-2 shadow-lg"
        :class="{ selected: gridModeEnabled }" />
    </label>
  </div>
</template>

<style scoped>
.toggle-button {
  background-color: var(--tower-v2-alt-bg-color);
  border: 1px solid var(--tower-v2-border-color);
}

.selected {
  background-color: var(--tower-v2-tool-selected-color);
}

.button:hover {
  background-color: var(--tower-v2-hover-color);
}
</style>
